import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import styles from '../../styles/DayInLife.module.css';

const missedCustomers = [
  {
    icon: '🔄',
    label: '재등록 연락할 고객',
    description: '만료 임박했는데 누구한테 연락해야 하지?'
  },
  {
    icon: '🎯',
    label: '체험 후 전환할 고객',
    description: '체험 레슨 끝났는데, 등록 권유 연락 드렸나?'
  },
  {
    icon: '😔',
    label: '요즘 뜸해진 고객',
    description: '열심히 다니다 갑자기 안 오시네...'
  }
];

export default function DayInLife() {
  const [ref, isVisible] = useScrollAnimation({ once: true });

  return (
    <section id="day-in-life" ref={ref} className={`section ${styles.dayInLife}`}>
      <div className="section-content">
        <h2 className={`text-center ${styles.title}`}>
          연락해야 할 <span className={styles.highlight}>고객을 놓치고</span> 계신가요?
        </h2>
        <p className={`text-center ${styles.subtitle}`}>
          코칭하랴, 운영하랴... 일일이 챙기기 어려운 게 당연합니다
        </p>

        <div className={`${styles.missedCustomers} ${isVisible ? styles.visible : ''}`}>
          {missedCustomers.map((item, index) => (
            <div
              key={index}
              className={styles.customerCard}
              style={{ transitionDelay: `${index * 0.15}s` }}
            >
              <div className={styles.customerIcon}>{item.icon}</div>
              <div className={styles.customerContent}>
                <h3 className={styles.customerLabel}>{item.label}</h3>
                <p className={styles.customerDesc}>{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className={`${styles.problemConclusion} ${isVisible ? styles.visible : ''}`}>
          <p className={styles.problemText}>
            담당자가 직접 리스트 뽑고, 일일이 연락하고...
          </p>
          <p className={styles.problemHighlight}>
            <strong>놓치는 고객이 생길 수밖에 없습니다</strong>
          </p>
        </div>

        <div className={`${styles.solutionBridge} ${isVisible ? styles.visible : ''}`}>
          <div className={styles.bridgeArrow}>↓</div>
          <p className={styles.bridgeText}>
            그런데 생각해보면...
          </p>
          <h3 className={styles.bridgeTitle}>
            <span className={styles.highlight}>쇼핑몰</span>은 이 문제를 이미 해결했어요
          </h3>
        </div>
      </div>
    </section>
  );
}
